module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('footer', {
    staticClass: "footer"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "content has-text-centered"
  }, [_c('p', [_c('span', {
    staticClass: "icon"
  }, [_c('i', {
    staticClass: "fa fa-code"
  })]), _vm._v(" with "), _c('span', {
    staticClass: "icon"
  }, [_c('i', {
    staticClass: "fa fa-heart"
  })]), _vm._v(" by "), _c('a', {
    attrs: {
      "href": "https://github.com/hecz0r"
    }
  }, [_vm._v("Said Sakuh")]), _vm._v(".")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2393bda2"}!./~/vue-loader/lib/selector.js?type=template&index=0!./client/components/layout/FooterBar.vue
// module id = 145
// module chunks = 14